import { render, staticRenderFns } from "./ActionBody.vue?vue&type=template&id=082d8020&"
import script from "./ActionBody.vue?vue&type=script&lang=js&"
export * from "./ActionBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports